



























import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const loginVuex = namespace("login");
@Component({})
export default class selectTenant extends Vue {
  ruleForm: any = {
    tenant: ""
  };
  rules: any = {
    tenant: [{ required: true }]
  };
  @loginVuex.State tenanList;
  @loginVuex.Action tenantAuthorization;
  async handleSubmit() {
    const $form: any = this.$refs.form;
    $form.validate(valid => {
      if (valid) {
        this.handleConfirm();
      }
    });
  }
  async handleConfirm() {
    const data = this.tenanList.find(
      item => item.tenantCode === this.ruleForm.tenant
    );

    await this.tenantAuthorization(data);
    localStorage.setItem("tenant", JSON.stringify(data));
    this.$emit("select");
  }
}
